import Api from "../../../../../componets/Api/Admin/Constants";

const AnyChange = (e, field, idx, arr) => {
    if (field==="required") arr[idx] = { ...arr[idx], required: e }
    if (field==="addtext") arr[idx] = { ...arr[idx], addtext: e }
    if (field==="addFile") arr[idx] = { ...arr[idx], addFile: e }
    if (field==="duplicated") arr[idx] = { ...arr[idx], duplicated: e }
    if (field==="param") arr[idx] = { ...arr[idx], param: e }
    if (field==="question") arr[idx] = { ...arr[idx], question: e }
    if (field==="options") arr[idx] = { ...arr[idx], options: e }
    if (field==="typeanswer") arr[idx] = { ...arr[idx], typeanswer: e }
    return arr
}



const ConstantsResolvers = async (type, props) => {
    const { _Resolvers, change, add, RESOLVERS, ApiRes, arr, idx, idx1 } = props;

    const ConstantsResolversTypeApi = {
        AdminConstatntsGetList: { ...props, AdminConstatntsGetList: true },
        AdminConstatntsGetMajorKey: { ...props, AdminConstatntsGetMajorKey: true },
        AdminConstantsPost: { ...props, AdminConstantsPost: true },
    }

    if (type === RESOLVERS.API) return await Api(ConstantsResolversTypeApi[ApiRes]);
}

export default ConstantsResolvers;